<template>
  <div>
    <nav-breadcrumb :menu="[{label: '保证金收支明细'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="listData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
        :is-pagination-show="false"
      >
        <div slot="TableTop">
          <el-col :span="6"><div class="Htitle-text color-deep-blue">渠道商名称：&nbsp;&nbsp;{{this.dealerName}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">缴纳总金额：&nbsp;&nbsp;{{this.totalAmount/10000|formatMoney}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">总笔数：&nbsp;&nbsp;{{this.listData.count}}</div></el-col>
        </div>

      </data-table>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "DepositTxList",
      data(){
        return {
          dealerId:this.$route.query['dealerId'] || '',
          dealerName:this.$route.query['dealerName'] || '',
          totalAmount:this.$route.query['totalAmount'] ||0,
          page: 1,
          pageSize: 20,
          listData: {},
          dealerOptions:[],
          filters: {
            labelWidth: '150px',
            form: {
              t__transactionDate:[],
              t__transactionTypeCode:'',

            },
            columns: [
              {
                label: '类型',
                component: 'el-select',
                field: 't__transactionTypeCode',
                options:[
                  {
                    label:'缴纳',
                    value:'DA'
                  },
                  {
                    label:'退还',
                    value:'DR'
                  }
                ],
                op: 'eq',
              },
              {
                label: '日期',
                component: 'date-range-picker',
                field: 't__transactionDate',
                op: ['gteq', 'lteq'],
              },
            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          },
          actions: [
            /*{
              label: '缴纳',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'addDA'
                })
              }
            },
            {
              label: '退还',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'addDR'
                })
              }
            }*/
          ],
        }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },
            {
              label: '类型',
              field: 't__transactionTypeCode',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            },
            {
              label: '日期',
              field: 't__transactionDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '金额',
              field: 't__txAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '流水号',
              field: 't__reference'
            },
            {
              label: '备注',
              field: 't__remarks'
            },
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize: 0,
              'xlist.sort.dataField': 't.transactionDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },
      mounted(){
        this.getData()
      },
      methods:{
        getData: function () {
          xhr.getDepositTxList(
            Object.assign({
              'dealerId':this.dealerId
            }, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.listData = res.data
                this.totalAmount = 0
                this.listData.data.forEach(item=>{
                  if(item.t__transactionTypeCode=='DR'){
                    this.totalAmount =  this.totalAmount -parseFloat( item.t__txAmount)*10000
                  }else{
                    this.totalAmount =  this.totalAmount + parseFloat( item.t__txAmount)*10000
                  }


                })
              } catch (e) {

              }
            })
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/DepositTxList.vue